module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hant/4-89d811324afa665370bdf149054446b0.jpg";